import Divider from "antd/es/divider";
import React from "react";
import styled from "styled-components";
import { Task } from "src/types/tasks";

interface TaskSummaryProps {
  selectedTasks: Task[];
}

export const TaskSummary: React.FC<TaskSummaryProps> = ({ selectedTasks }) => {
  return (
    <SummaryContainer>
      <h1>Selected Tasks</h1>
      <br />
      {selectedTasks.length === 0 ? (
        <EmptyState>
          <EmptyIcon>📋</EmptyIcon>
          <EmptyText>No tasks selected yet</EmptyText>
          <EmptySubtext>
            Select tasks from the catalog to see them here
          </EmptySubtext>
        </EmptyState>
      ) : (
        <>
          {selectedTasks.map((task) => (
            <React.Fragment key={task.service_id}>
              <p className="flex justify-content-between">
                <span>{task.title}</span>
                <span className="blue">
                  ${(task.current_price_cents / 100).toFixed(2)}
                </span>
              </p>
            </React.Fragment>
          ))}
          <Divider style={{ color: "#B1DCE5" }} />
        </>
      )}
    </SummaryContainer>
  );
};

const SummaryContainer = styled.div`
  padding: 25px;
  background-color: #eefcff;
  flex: 1;
  overflow-y: auto;
  min-height: 200px;

  h1 {
    margin-top: 1vh;
    font-weight: 600;
    color: #373744;
  }

  .blue {
    font-weight: 600;
    color: #323593;
  }

  color: #000;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  min-height: 200px;
`;

const EmptyIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
`;

const EmptyText = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: #373744;
  margin: 0 0 8px 0;
`;

const EmptySubtext = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
`;
